import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../../become-a-customer-feature.selector';

export const putConfirmationState = createSelector(
  getBecomeACustomerState,
  (state) => state.confirmation.putConfirmation
);
